<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-table-dialog"
  >
    <div class="form-content">
      <Form
        ref="outform"
        @submit="submit"
      ></Form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import Form from "@/components/sys/dataPermission/dimension-list/form";
import {addTable} from "@/api/sys/dataPermission/tableList";
import {addDimension} from "../../../../api/sys/dataPermission/dimensionList";

export default {
  name: "addDialog",
  components: {
    Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form,menuIdList) {
      let params = {
        ...form,
      }
      addDimension(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-table-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
